<template>
  <div class="p-configurator" id="carlineup">
    <side-banner />
    <the-title :title="title" />
    <div class="p-configurator__inner contents__section">
      <div>
        <ul class="grid_width">
          <li
            v-for="(car_list, index) in car_lists"
            :key="index"
            class="li_grid"
          >
            <img :src="car_list.image" :id="car_list.code" class="img_mb" />
            <hr color="#d9d9d6" size="1" class="hr_296" />
            <p class="cat_p_text renalutFont">
              {{ car_list.name }}
            </p>
            <p class="jp_name">
              {{ car_list.name_jp }}
            </p>
            <p class="jp_name" v-if="car_list.e_tech==='true' && car_list.code === 'CA'">
              <img src="../../public/images/NEW-FULL-HYBRID-E-TECH.png" class="new-e-tech" />
            </p>
            <p class="jp_name" v-else-if="car_list.e_tech==='true'">
              <img src="../../public/images/E-TECH-HYBRIDicon.png" class="e-tech" />
            </p>
            <div class="choice">
              <button class="btn" @click="clickCar(car_list.code, index)">
                選択する
              </button>
            </div>
            <div class="link_btn">
              <a :href="car_list.detail_url" class="text_gray" target="_blank"
                >詳しく見る<img
                  src="../../public/images/Vector2.svg"
                  class=""
                  alt=""
              /></a>
            </div>
            <hr color="#d9d9d6" size="1" class="detail_line" />
          </li>
        </ul>
      </div>
    </div>
    <bottom-banner />
  </div>
</template>

<script>
import TheTitle from "../components/Title.vue";
import SideBanner from "../components/SideBanner";
import RjConfiguration from "../functions/RjConfiguration";
import BottomBanner from "../components/BottomBanner.vue";

export default {
  components: {
    SideBanner,
    TheTitle,
    BottomBanner,
  },
  setup() {
    const RJ = RjConfiguration();
    const car_lists = RJ.getListCarLineup();
    const clickCar = (pCode, pIndex) => {
      RJ.selectConfiguration("code", pCode, pIndex);
    };
    return {
      title: { main: "CONFIGURATOR", sub: "コンフィギュレーター" },
      car_lists,
      clickCar,
    };
  },
};
</script>
<style lang="scss" scoped></style>
